export * from "-!../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./general.vue?vue&type=template&id=1f7933b3&scoped=true"


//////////////////
// WEBPACK FOOTER
// ./src/components/clients/client/settings/general.vue?vue&type=template&id=1f7933b3&scoped=true
// module id = xNAa
// module chunks = 0